import type { NextPage } from "next";
import { GetStaticPropsContext } from "next";

import { SubmitPageModule } from "modules/SubmitPage";
import { AppLayout } from "types";

import { ProjectDataStep } from "modules/SubmitPage/steps/ProjectDataStep";

const SubmitPage: NextPage = () => (
  <SubmitPageModule>
    <ProjectDataStep />
  </SubmitPageModule>
);

export async function getStaticProps(context: GetStaticPropsContext) {
  return {
    props: {
      appLayout: AppLayout.SUBMIT_PAGE,
    },
  };
}

export default SubmitPage;
